import React from 'react';
import ProductItemView from '../ProductItemViewMobile';
import mid247 from '../../resource/middleware_mobile/247.png';

const AlldayMobile = () => {
    return (
        <ProductItemView
            title="Funcionamiento 24/7 sin intervención humana"
            items={["Mecanismos de chequeo y reconexión automática", "Mas de 450 escenarios testeados automaticamente"]}
            image={mid247}
            centered
            withGap />
    );
};

export default AlldayMobile;